// extracted by mini-css-extract-plugin
export var legendIndicator = "_9i-1";
export var legendRight = "_9i-0";